module.exports = __webpack_public_path__ + "img/transformdata-image2.b699f3f5.png";